import constants from 'constants/index'

const { DISAPPROVED_STATUS_LABEL, PENDING_STATUS_LABEL, STATUSES } =
  constants.privacyByDesign

// Projeto só volta a ser editável/enviável/excluível enquanto está pendente ou
// depois de reprovado — as demais situações são de responsabilidade do revisor.
const EDITABLE_STATUSES = [PENDING_STATUS_LABEL, DISAPPROVED_STATUS_LABEL]

const canEdit = (status) => EDITABLE_STATUSES.includes(status)

const canSendToReview = (status) => EDITABLE_STATUSES.includes(status)

const canDelete = (status) => EDITABLE_STATUSES.includes(status)

const getStatusLabel = (status) => STATUSES[status] || status

const status = { canDelete, canEdit, canSendToReview, getStatusLabel }

export default status
